import { httpResource } from '@angular/common/http';
import { Service, computed, inject, signal } from '@angular/core';
import { SentimentClient } from '@shared/api/conversations/clients/sentiment.client';
import type { SentimentsResponse } from '@shared/api/conversations/dtos/responses/sentiments.response';

@Service()
export class SentimentReferenceService {
  private readonly client = inject(SentimentClient);

  private readonly requested = signal(false);

  private readonly request = httpResource<SentimentsResponse>(() => (this.requested() ? this.client.buildSentimentsRequest() : undefined));

  readonly sentiments = computed(() => (this.request.hasValue() ? (this.request.value().sentiments ?? []) : []));

  readonly isUnavailable = computed(() => this.request.status() === 'error');

  readonly error = this.request.error;

  readonly isLoading = this.request.isLoading;

  load(): void {
    this.requested.set(true);
  }

  reload(): void {
    this.request.reload();
  }

  clear(): void {
    this.requested.set(false);
  }
}
